import { css } from '@emotion/react'
import styled from '@emotion/styled'

const contactStyles = ({ theme }) => css`
  label: contact;

  margin: 10px 0 0 0;

  &:nth-child(odd) {
    margin-right: 35px;
  }

  ${theme.media.mega} {
    display: inline-block;

    margin: 20px 0 0 0;

    &:nth-child(odd) {
      margin-right: 85px;
    }
  }
`

const contactsContainerStyles = ({ theme }) => css`
  label: contacts--container;

  padding: 0;
  border: none;

  margin: 70px 0 50px 0;

  ${theme.media.mega} {
    border: 1px solid ${theme.colors.n100};
    box-sizing: border-box;

    padding: 40px;
    margin: 80px 0 45px 0;
  }
`

const containerFlexStyles = ({ theme }) => css`
  label: container--flex;

  display: flex;
  flex-direction: column;

  margin: 10px 0 0 0;

  ${theme.media.giga} {
    justify-content: space-between;
    flex-direction: row;

    margin: 20px 0 0 0;
  }
`

const faqItemStyles = ({ theme }) => css`
  label: faq--item;

  margin: 0 0 ${theme.spacings.kilo} 0;

  border-bottom: 1px solid ${theme.colors.n200};

  &:last-child {
    margin: 0;

    border: none;
  }
`

const faqListStyles = ({ theme }) => css`
  label: faq--list;

  margin: 20px 0 0 0;

  ${theme.media.mega} {
    margin: 38px 0 0 0;
  }
`

const sectionStyles = ({ theme }) => css`
  label: section;

  padding: 20px;

  ${theme.media.giga} {
    float: left;
    width: 100%;

    background: white;

    padding: 50px 97px 70px 97px;

    box-sizing: border-box;
  }
`

const separatorStyles = ({ theme }) => css`
  label: separator;

  height: 1px;
  width: 30%;

  background: ${theme.colors.n200};

  margin: ${theme.spacings.mega} 0;

  ${theme.media.giga} {
    width: 1px;
    height: auto;

    margin: 0;
  }
`

const containerAssistantStyles = () => css`
  label: container--assistant;

  min-width: 280px;
`

const buttonChatBotStyles = ({ theme }) => css`
  label: button--chatbot;

  width: 90%;
  height: 55px;

  margin: 10px 0 0 0;

  cursor: pointer;
  outline: 0;

  background-image: url(${window && window.env.assetHost}assets/images/lmcv/ajuda/lia.svg);

  background-size: contain;
  background-repeat: no-repeat;

  ${theme.media.giga} {
    width: 305px;
  }
`

export const Contact = styled('div')(contactStyles)
export const ContactsContainer = styled('article')(contactsContainerStyles)
export const ContainerFlex = styled('div')(containerFlexStyles)
export const FaqItem = styled('li')(faqItemStyles)
export const FaqList = styled('ul')(faqListStyles)
export const Section = styled('section')(sectionStyles)
export const Separator = styled('div')(separatorStyles)
export const ContainerAssistant = styled('div')(containerAssistantStyles)
export const ButtonChatBot = styled('button')(buttonChatBotStyles)
